import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { LoginService } from 'src/app/common/services/Login.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { constObj } from 'src/app/common/Constants/constants';
import { ConfirmDialogComponent } from 'src/app/common/shared-components/confirm-dialog/confirm-dialog.component';
import { filter, finalize, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { SessionService } from '../../common/services/Session.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {

  @Output() callROC = new EventEmitter();
  constructor(
    private commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private route: Router,
    private loginService: LoginService, private session: SessionService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {
  }

  private destroy$: Subject<void> = new Subject<void>();
  navData = {
    crumbData: [],
    menuData: [],
  }
  footerLinkData = [];
  showFooterMenu: boolean = false;
  showFooterPrintMenu: boolean = false;
  showFooterDisplayMenu: boolean = false;

  globalprint: string;
  printtoc: string;
  printselected: string;
  printannotations: string;
  printSources: string;
  generalFeedback: string = "";
  displayAllAnnotations: string;
  HideAllAnnotations: string;
  displayAllSources: string;
  displaySecContent: string;
  hideSecContent: string;
  displayLabel: string;
  printQueueCount: number = 0;
  userSessionRole: string;
  userSessionRolePermission: boolean = false;
  body;
  printOption: boolean = false;
  displayOption: boolean = false;
  displaySourcesParagraphArray = [];
  /*printqueuecount = this.commonDataService.printqueueCount.subscribe();  */
  hiddenContentSECFlag = false;
  hiddenContentSECText = '';
  yourAnnotationCount = [];
  showSourcesCount = [];

  footerAPIResponse;

  temproutes = [
    "about-us",
    "copy-right",
    "contact-us",
    "help",
    "terms-and-conditions",
    ""
  ]
  hideFooterLabelsOnArchive: boolean = false;
  clonedNavData = {
    crumbData: [],
    menuData: [],
  };

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.printOption = false;
    this.displayOption = false;
    this.deletePrintQueueForNewPage();

    // this.commonDataService.resetSourcesAndAnnotations.pipe(takeUntil(this.destroy$)).subscribe(data => {
    this.yourAnnotationCount = [];
    this.showSourcesCount = [];
    ///});
    this.commonDataService.resetPrintQueue.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.deletePrintQueueForNewPage();
    });
    this.commonDataService.deleteAnnotation.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.yourAnnotationCount = this.yourAnnotationCount.filter(a => a !== data);
      }
      this.toggleAnnotationFooterLabel();
    });

    this.commonDataService.annotationWithinContent.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        if (!this.yourAnnotationCount.some(a => a === data)) {
          this.yourAnnotationCount.push(data);
        }
        this.toggleAnnotationFooterLabel();
      }
    });

    this.commonDataService.showSources.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        if (data.toggleValue) {
          if (!this.showSourcesCount.some(a => a === data.paragraphId)) {
            this.showSourcesCount.push(data.paragraphId);
          }
        }
        else {
          this.showSourcesCount = this.showSourcesCount.filter(a => a !== data.paragraphId);
        }

        if (this.showSourcesCount?.length > 0) {
          let obj = this.DisplayValue.filter(a => a.id == 'displayAllSources')[0];
          let index = this.DisplayValue.indexOf(obj);
          obj.labels = ["Hide all sources"];
          if (index != -1) {
            this.DisplayValue[index] = obj;
          }
        }
        else {
          let obj = this.DisplayValue.filter(a => a.id == 'displayAllSources')[0];
          let index = this.DisplayValue.indexOf(obj);
          obj.labels = ["Display all sources"];
          if (index != -1) {
            this.DisplayValue[index] = obj;
          }
        }
      }
    });

    let breadcrumbUrlSplits = this.route.url.split("/");
    let breadcerumbUrl: string = "";
    if (breadcrumbUrlSplits.length == 2) {
      if (breadcrumbUrlSplits[1].split("-").length > 2) { breadcerumbUrl = breadcrumbUrlSplits[1].split("-")[0] + "-" + breadcrumbUrlSplits[1].split("-")[1] + "-" + breadcrumbUrlSplits[1].split("-")[2] + "-navPath"; } else { breadcerumbUrl = this.route.url.split("/")[1] }
    }
    else if (breadcrumbUrlSplits.length == 3) {
      if (this.route.url.split("/")[2] == "tableOfContent" || this.route.url.split("/")[2] == "showallinonepage" || this.route.url.split("/")[2] == "showallinonepageplus") { breadcerumbUrl = this.route.url.split("/")[1] + "-navPath"; }
      else {
        breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
      }
    }
    else if (breadcrumbUrlSplits.length > 3) {
      if (this.route.url.split("/")[3] == "showallinonepage" || this.route.url.split("/")[3] == "showallinonepageplus") {
        let topic = parseInt(this.route.url.split("/")[1].replace(/[A-Z]/g, ''));
        let subtopic = parseInt(this.route.url.split("/")[2].replace(/[A-Z]/g, ''));
        if (topic == subtopic) {
          breadcerumbUrl = topic + "-navPath";
        }
        else {
          breadcerumbUrl = topic + "-" + subtopic + "-navPath";
        }
      }
      else {
        breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
      }
    }
    if (breadcerumbUrl != "Home") {
      let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      if (leftNavigation == undefined || leftNavigation == null) {
        forkJoin(this.graphQlService.GetBreadcrumbSession(breadcerumbUrl), this.graphQlService.getGlobalFooter(), this.graphQlService.getGlobalLabels()).subscribe(([data, glosbalFooterData, globalLabels]) => {
          this.commonDataService.globalLabels.next(globalLabels);
          this.showFooterMenu = false;
          this.footerLinkData = glosbalFooterData;
          this.PrintValue = [];
          this.DisplayValue = [];
          this.getPrintDisplayMenus(globalLabels);
          this.session.assignglobalinfo(globalLabels);
          this.navData = JSON.parse(JSON.stringify(data));
          this.clonedNavData = Object.assign([], this.navData);
          this.filterBreadCrumbBasedOnRole();
        });
      }
      else {
        forkJoin(this.graphQlService.getGlobalFooter(), this.graphQlService.getGlobalLabels()).subscribe(([glosbalFooterData, globalLabels]) => {
          this.commonDataService.globalLabels.next(globalLabels);
          this.showFooterMenu = false;
          this.footerLinkData = glosbalFooterData;
          this.PrintValue = [];
          this.DisplayValue = [];
          this.getPrintDisplayMenus(globalLabels);
          this.session.assignglobalinfo(globalLabels);

          if (breadcerumbUrl.includes("navPath")) { this.getBreadcrumbWithNavPath(breadcerumbUrl); }
          else {
            this.getBreadcrumb(breadcerumbUrl);
          }
          this.clonedNavData = Object.assign([], this.navData);
          this.filterBreadCrumbBasedOnRole();
        });
      }
    }
    else {
      this.graphQlService.getGlobalFooter().subscribe(glosbalFooterData => {
        this.showFooterMenu = false;
        this.footerLinkData = glosbalFooterData;
      });
      this.navData.crumbData = null;
      this.printOption = false;
      this.displayOption = false;
      if (this.session.globallablesinfo != null) {
        this.PrintValue = [];
        this.DisplayValue = [];
        this.getPrintDisplayMenus(this.session.globallablesinfo);

      } else {
        this.graphQlService.getGlobalLabels().subscribe(labels => {
          this.PrintValue = [];
          this.DisplayValue = [];
          this.commonDataService.globalLabels.next(labels);
          this.getPrintDisplayMenus(labels);
          this.session.assignglobalinfo(labels);

        })
      }
    }

    //this.commonDataService.displayallannotation.pipe(takeUntil(this.destroy$)).subscribe(data => {
    //  if (data == "default") {
    //    var dispval = this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)
    //    if (dispval.length > 0) { this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)[0].labels = this.displayAllAnnotations; }
    //  }
    //});

    this.commonDataService.printqueueCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.printQueueCount = (this.printQueueCount < 0) ? 0 : this.printQueueCount;
        if (data.toggleValue.toString() == 'true') {
          this.printQueueCount = this.printQueueCount + 1;
        }
        else {
          if (data.toggleValue.toString() == 'false') {
            this.printQueueCount = this.printQueueCount - 1;
          }
        }
      }
    })
    let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
    if (printQueueData != null) {
      this.printQueueCount = printQueueData.ParagraphIdsList.length;
    }
    this.commonDataService.printCount.pipe(takeUntil(this.destroy$)).subscribe(data => {

      if (data == "0") {
        this.printQueueCount = 0;
      }
    })

    if (this.DisplayValue.length > 0) {
      if (this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations).length > 0) {
        this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)[0].labels = this.displayAllAnnotations;
      }
    }
    this.event$
      = this.route.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.yourAnnotationCount = [];
          this.showSourcesCount = [];
          this.showFooterMenu = false;
          this.deletePrintQueueForNewPage();
          breadcrumbUrlSplits = this.route.url.split("/");
          //breadcerumbUrl: string = "";
          if (breadcrumbUrlSplits.length == 2) {
            if (breadcrumbUrlSplits[1].split("-").length > 2) { breadcerumbUrl = breadcrumbUrlSplits[1].split("-")[0] + "-" + breadcrumbUrlSplits[1].split("-")[1] + "-" + breadcrumbUrlSplits[1].split("-")[2] + "-navPath"; } else { breadcerumbUrl = this.route.url.split("/")[1] }
          }
          else if (breadcrumbUrlSplits.length == 3) {
            if (this.route.url.split("/")[2] == "tableOfContent" || this.route.url.split("/")[2] == "showallinonepage" || this.route.url.split("/")[2] == "showallinonepageplus") { let topic = parseInt(this.route.url.split("/")[1].replace(/[A-Z]/g, '')); breadcerumbUrl = topic + "-navPath"; }
            else {
              breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
            }
          } else if (breadcrumbUrlSplits.length > 3) {
            if (this.route.url.split("/")[3] == "showallinonepage" || this.route.url.split("/")[3] == "showallinonepageplus") {
              let topic = parseInt(this.route.url.split("/")[1].replace(/[A-Z]/g, ''));
              let subtopic = parseInt(this.route.url.split("/")[2].replace(/[A-Z]/g, ''));
              if (topic == subtopic) {
                breadcerumbUrl = topic + "-navPath";
              }
              else {
                breadcerumbUrl = topic + "-" + subtopic + "-navPath";
              }
            }
            else {
              breadcerumbUrl = this.route.url.split("/")[1] + "/" + this.route.url.split("/")[2]
            }
          }
          if (breadcerumbUrl != "Home") {
            let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
            if (leftNavigation == undefined || leftNavigation == null) {
              this.graphQlService.GetBreadcrumbSession(breadcerumbUrl).subscribe(data => {
                this.showFooterMenu = false;
                this.navData = JSON.parse(JSON.stringify(data));
                this.clonedNavData = Object.assign([], this.navData);
                this.filterBreadCrumbBasedOnRole();
              });
            }
            else {
              if (breadcerumbUrl.includes("navPath")) { this.getBreadcrumbWithNavPath(breadcerumbUrl); }
              else {
                this.getBreadcrumb(breadcerumbUrl);
              }
              this.clonedNavData = Object.assign([], this.navData);
              this.filterBreadCrumbBasedOnRole();
            }
          } else {
            this.navData.crumbData = null;
            this.printOption = false;
            this.displayOption = false;
          }
          if (this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations).length > 0) {
            this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)[0].labels = this.displayAllAnnotations;
          }
        });
    this.commonDataService.displayAllSourcesToggleLabel.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        let obj = this.DisplayValue.filter(a => a.id == 'displayAllSources')[0];
        let index = this.DisplayValue.indexOf(obj);
        if (data?.toString()?.toLowerCase() === 'show') {
          obj.labels = ["Hide all sources"];
        }
        else if (data?.toString()?.toLowerCase() === 'hide') {
          obj.labels = ["Display all sources"];
        }
        if (index != -1) {
          this.DisplayValue[index] = obj;
        }
      }
    });
  }

  event$;
  breadCrumbMenuData: any[]
  filterBreadCrumbBasedOnRole() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.filterBreadcrumb(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.filterBreadcrumb(this.session.userInfo);
    }
  }
  DisplayValue: any[] = [];
  PrintValue: any[] = [];

  filterBreadcrumb(sessiondata) {
    if (this.hiddenContentSECFlag) {
      this.navData.menuData = this.navData.menuData?.filter(x => !x.menuItem.startsWith("S"));
      this.breadCrumbMenuData = this.navData.menuData;
    } else {
      this.breadCrumbMenuData = this.navData.menuData;
    }
    this.userSessionRole = sessiondata.user.roles;
    this.userSessionRolePermission = true;
    this.GetPrintLables();
    this.GetDisplayLables();
    if (this.userSessionRole == "Basic") {
      this.breadCrumbMenuData = this.navData?.menuData?.filter(x => x.menuItem != "Redis Cache Management" && x.menuItem != "My Bookmarks" && x.menuItem != "My Account Details" && x.menuItem != "My History" && x.menuItem != "My Annotations" /*&& x.menuItem != "My Subscription Information" && x.menuItem != "Current Activity" && x.item != "Analytics" */&& x.menuItem != "Implementation Q&A")
    }
    //else if (sessiondata.user.roles == "Academic") {
    //  this.breadCrumbMenuData = this.navData?.menuData?.filter(x => x.menuItem != "My Bookmarks" && x.menuItem != "My Annotations" && x.menuItem != "My Subscription Information" && x.menuItem != "My Account Details" && x.menuItem != "Current Activity" && x.item != "Analytics");
    //}
    //else {
    //  let isAdmin = localStorage.getItem("isAdmin") == "true" ? true : false;
    //  if (!isAdmin) {
    //    this.breadCrumbMenuData = this.navData?.menuData?.filter(x => x.menuItem != "Current Activity" && x.item != "Analytics" && x.item != "Access Management");
    //  }
    //}
  }

  footer(obj: any, event: any) {
    event.preventDefault();
    if (obj.displayText == "FASB.org") {
      window.open(obj.link);
    }
    else if (obj.displayText == "Contact Us") {
      this.generalFeedback = "General Feedback";
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.rightOverlayOption.next(this.generalFeedback);
    }
    //else if (obj.displayText == "About") {
    //  this.graphQlService.getS3BucketPath().subscribe(data => {
    //    let url = data + "/" + obj.link;
    //    window.open(url);
    //  });
    //}
    else if (obj.displayText == "Terms and Conditions") {
      this.commonDataService.tcsource.next("");
      //this.route.navigate([obj.link]);
      this.popupRedirect(obj.link);
    }
    else {
      if (obj.link != "") {
        //this.route.navigate([obj.link]);
        this.popupRedirect(obj.link);
      }
    }
  }

  footerMenuClicked(e) {
    this.showFooterPrintMenu = false;
    this.showFooterDisplayMenu = false;
    if (e) {
      this.showFooterMenu = !this.showFooterMenu;
    }
  }

  closeFooterMenu() {
    this.showFooterMenu = false;
  }

  footerDisplayClicked() {
    this.showFooterPrintMenu = false;
    this.showFooterMenu = false;
    this.showFooterDisplayMenu = !this.showFooterDisplayMenu;
  }
  footerPrintClicked(e) {
    this.showFooterMenu = false;
    this.showFooterDisplayMenu = false;
    this.showFooterPrintMenu = !this.showFooterPrintMenu;
  }

  ChangeSelectedItem(selectedMenu) {
    if (selectedMenu.menuUrl != null || selectedMenu.menuUrl != "") {
      let menuUrls = selectedMenu.menuUrl.split("/");
      let pageUrls = this.route.url.split("/");
      if (menuUrls.length > 1) {
        if (menuUrls[1] != pageUrls[2]) {
          //var len = this.navData.crumbData.length;
          ////this.navData.crumbData[len - 1] = selectedMenu.item;
          //var obj = {
          //  crumbData: this.navData.crumbData,
          //  menuData: this.navData.menuData
          //}
          //this.navData = obj;
          if (selectedMenu.menuItem == "Logout") {
            this.getLogoutURL()
          }

          else {
            //this.route.navigate([selectedMenu.menuUrl]);
           this.popupRedirect(selectedMenu.menuUrl);
          }
        }
      }
      else if (menuUrls.length == 1) {
        if (menuUrls[0] != pageUrls[1] && menuUrls[0] != "") {
         // this.route.navigate(["/" + selectedMenu.menuUrl]);
          this.popupRedirect("/" + selectedMenu.menuUrl);
        }
      }
    }
    this.showFooterMenu = false;
  }
  /* Start -- Print queue functionality request MS-415*/
  popupRedirect(url) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      localStorage.setItem("isConfirmPopup", 'true');
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          this.route.navigate([url]);
        }
      });
      //  return;
    }
    else {
      this.route.navigate([url]);
    }
  }
  /* End -- Print queue functionality request MS-415*/
  getLogoutURL() {
    this.loginService.getlogoutURL(window.location.origin).subscribe(data => {
      this.loginService.deleteSession().subscribe();
      window.location.href = data.logoutRedirectURL;
    })
  }

  getPrintDisplayMenus(data) {
    if (data != null) {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.globalprint = labels.filter(x => x.key == "global_print").map(y => y.value);
      this.printtoc = labels.filter(x => x.key == "print_toc").map(y => y.value);
      this.printselected = labels.filter(x => x.key == "print_selected").map(y => y.value);
      this.printannotations = labels.filter(x => x.key == "print_annotations").map(y => y.value);
      this.printSources = labels.filter(x => x.key == "print_sources").map(y => y.value);
      this.hiddenContentSECText = labels.filter(x => x.key == "hidden_content_sec_text").map(y => y.value);//"Hidden Content: SEC";

      this.displayLabel = labels.filter(x => x.key == "display_displayLabel").map(y => y.value);
      this.displayAllAnnotations = labels.filter(x => x.key == "display_displayAllAnnotations").map(y => y.value);
      this.displayAllSources = labels.filter(x => x.key == "display_displayAllSources").map(y => y.value);
      this.displaySecContent = labels.filter(x => x.key == "display_displaySecContent").map(y => y.value);
      this.hideSecContent = labels.filter(x => x.key == "display_hideSecContent").map(y => y.value);
      this.HideAllAnnotations = labels.filter(x => x.key == "display_hideAllAnnotations").map(y => y.value);
      this.PrintValue.push({ 'labels': this.globalprint, 'DisplayOrNot': true });
      //this.PrintValue.push({ 'labels': this.printtoc, 'DisplayOrNot': true });
      this.PrintValue.push({ 'labels': this.printannotations, 'DisplayOrNot': true });
      this.PrintValue.push({ 'labels': this.printSources, 'DisplayOrNot': true });
      this.PrintValue.push({ 'labels': this.printselected, 'deletedIcon': true, 'printselectedCount': true, 'DisplayOrNot': true });

      this.DisplayValue.push({
        'labels': this.displayAllAnnotations, 'imgPath': '../../../assets/icons/MyAnnotation-black.svg',
        'id': 'displayAllAnnotations', 'alt': 'Annotations', 'DisplayOrNot': true
      });
      this.DisplayValue.push({
        'labels': this.displayAllSources, 'imgPath': '../../../assets/icons/ShowSources.svg',
        'id': 'displayAllSources', 'alt': 'Sources', 'DisplayOrNot': true
      });
      if (localStorage.getItem("DefaultSecView") == "true") {
        this.DisplayValue.push({
          'labels': this.hideSecContent, 'imgPath': '../../../assets/icons/layout-list-thumb.svg',
          'id': 'hideSecContent', 'alt': 'Sec Content', 'DisplayOrNot': true
        });
      }
      else {
        this.DisplayValue.push({
          'labels': this.displaySecContent, 'imgPath': '../../../assets/icons/layout-list-thumb.svg',
          'id': 'displaySecContent', 'alt': 'Sec Content', 'DisplayOrNot': true
        });
      }

    }
  }

  GetPrintLables() {
    let routerpart = this.route.url.split("/");
    if (this.route.url.includes("showallinonepage")) {
      this.printOption = true;
      this.PrintValue[0].DisplayOrNot = true;
      this.PrintValue[1].DisplayOrNot = false;
      this.PrintValue[2].DisplayOrNot = true;
      this.PrintValue[3].DisplayOrNot = false;
    }
    else if (routerpart.length == 2) {
      if (routerpart[1].split("-").length > 2 && this.route.url != "/terms-and-conditions" && !(this.route.url.includes("search?query"))) {
        this.printOption = true;
        this.PrintValue[0].DisplayOrNot = true;
        this.PrintValue[1].DisplayOrNot = this.userSessionRole != "Academic" && this.userSessionRole != "Basic" ? true : false;
        this.PrintValue[2].DisplayOrNot = true;
        this.PrintValue[3].DisplayOrNot = true;
      }
      else if (this.route.url == "/Home" || this.route.url == "/myBookmarks" || this.route.url == "/crossreference" || this.route.url == "/myaccountdetails" ||
        this.route.url == "/MyHistory" || this.route.url == "/myAnnotations" || this.route.url == "/pendingcontentsystemagreement" || this.route.url == "/pendingcontentintegeration" ||
        this.route.url == "/pendingcontentsystem" || this.route.url == "/supersededstandards" || this.route.url == "/aicpa" || this.route.url == "/conceptsstatements" || this.route.url == "/search" || this.route.url == "/taxonomyelementsreferencefile") {
        this.printOption = false;
      }
      else if (this.route.url == "/about-us" || this.route.url == "/MasterGlossary" || this.route.url == "/copy-right" || this.route.url == "/terms-and-conditions" || this.route.url.includes("/help") || this.route.url.includes("/relatedproposedasus") || this.route.url.includes("/pcsfaq")) {
        this.printOption = true;
        this.PrintValue[0].DisplayOrNot = true;
        this.PrintValue[1].DisplayOrNot = false;
        this.PrintValue[2].DisplayOrNot = false;
        this.PrintValue[3].DisplayOrNot = false;
      }
    }
    else if (routerpart.length == 4) {
      if (this.route.url.includes("archiveContent")) {
        this.printOption = true;
        this.PrintValue[0].DisplayOrNot = true;
        this.PrintValue[1].DisplayOrNot = false;
        this.PrintValue[2].DisplayOrNot = true;
        this.PrintValue[3].DisplayOrNot = false;
      }
      else if (this.navData.crumbData != null) {
        if (this.navData.crumbData[0] != "Other Sources") {
          this.printOption = true;
          this.PrintValue[0].DisplayOrNot = true;
          this.PrintValue[1].DisplayOrNot = this.userSessionRole != "Academic" && this.userSessionRole != "Basic" ? true : false;
          this.PrintValue[2].DisplayOrNot = true;
          this.PrintValue[3].DisplayOrNot = true;
        }
        else {
          this.printOption = true;
          this.PrintValue[0].DisplayOrNot = true;
          this.PrintValue[1].DisplayOrNot = false;
          this.PrintValue[2].DisplayOrNot = false;
          this.PrintValue[3].DisplayOrNot = false;
        }
      }
      else {
        let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (leftNavigation == undefined || leftNavigation == null) {
          this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
            this.navData = JSON.parse(JSON.stringify(data));
          });
        }
        else {
          this.getBreadcrumb(this.route.url);
        }
        if (this.navData.crumbData != null) {
          if (this.navData.crumbData[0] != "Other Sources") {
            this.printOption = true;
            this.PrintValue[0].DisplayOrNot = true;
            this.PrintValue[1].DisplayOrNot = this.userSessionRole != "Academic" && this.userSessionRole != "Basic" ? true : false;
            this.PrintValue[2].DisplayOrNot = true;
            this.PrintValue[3].DisplayOrNot = true;
          }
          else {
            this.printOption = true;
            this.PrintValue[0].DisplayOrNot = true;
            this.PrintValue[1].DisplayOrNot = false;
            this.PrintValue[2].DisplayOrNot = false;
            this.PrintValue[3].DisplayOrNot = false;
          }
        }
        else {
          this.printOption = false;
        }
      }
    }
    else if (routerpart.length == 3 && !this.route.url.includes("tableOfContent")) {
      if (this.navData.crumbData != null) {
        if (this.navData.crumbData[0] != "Other Sources" && (!this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements"))) {
          this.printOption = true;
          this.PrintValue[0].DisplayOrNot = true;
          this.PrintValue[1].DisplayOrNot = this.userSessionRole != "Academic" && this.userSessionRole != "Basic" ? true : false;
          this.PrintValue[2].DisplayOrNot = true;
          this.PrintValue[3].DisplayOrNot = true;
        }
        //else if (this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements")) {
        //  this.printOption = true;
        //  this.PrintValue[0].DisplayOrNot = true;
        //  this.PrintValue[1].DisplayOrNot = false;
        //  this.PrintValue[2].DisplayOrNot = false;
        //  this.PrintValue[3].DisplayOrNot = false;
        //}
        else {
          this.printOption = true;
          this.PrintValue[0].DisplayOrNot = true;
          this.PrintValue[1].DisplayOrNot = false;
          this.PrintValue[2].DisplayOrNot = false;
          this.PrintValue[3].DisplayOrNot = false;
        }
      }
      else {
        let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (leftNavigation == undefined || leftNavigation == null) {
          this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
            this.navData = JSON.parse(JSON.stringify(data));
          });
        }
        else {
          this.getBreadcrumb(this.route.url);
        }
        if (this.navData.crumbData != null) {
          if (this.navData.crumbData[0] != "Other Sources" && (!this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements"))) {
            this.printOption = true;
            this.PrintValue[0].DisplayOrNot = true;
            this.PrintValue[1].DisplayOrNot = this.userSessionRole != "Academic" && this.userSessionRole != "Basic" ? true : false;
            this.PrintValue[2].DisplayOrNot = true;
            this.PrintValue[3].DisplayOrNot = true;
          }
          //else if (this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements")) {
          //  this.printOption = true;
          //  this.PrintValue[0].DisplayOrNot = true;
          //  this.PrintValue[1].DisplayOrNot = false;
          //  this.PrintValue[2].DisplayOrNot = false;
          //  this.PrintValue[3].DisplayOrNot = false;
          //}
          else {
            this.printOption = true;
            this.PrintValue[0].DisplayOrNot = true;
            this.PrintValue[1].DisplayOrNot = false;
            this.PrintValue[2].DisplayOrNot = false;
            this.PrintValue[3].DisplayOrNot = false;
          }
        }
        else {
          this.printOption = false;
        }
      }
    }
    else if (routerpart.length == 3 && this.route.url.includes("tableOfContent")) {
      this.printOption = true;
      this.PrintValue[0].DisplayOrNot = true;
      this.PrintValue[1].DisplayOrNot = false;
      this.PrintValue[2].DisplayOrNot = false;
      this.PrintValue[3].DisplayOrNot = false;
    }
  }

  GetDisplayLables() {
    let routerpart = this.route.url.split("/");

    if (this.route.url.includes("showallinonepage")) {
      this.displayOption = true;
      this.DisplayValue[0].DisplayOrNot = false;
      this.DisplayValue[1].DisplayOrNot = true;
      this.DisplayValue[2].DisplayOrNot = true;
    }
    else if (routerpart.length == 2) {
      if (routerpart[1].split("-").length > 2 && this.route.url != "/terms-and-conditions" && !(this.route.url.includes("search?query"))) {
        this.displayOption = true;
        this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
        this.DisplayValue[1].DisplayOrNot = true;
        this.DisplayValue[2].DisplayOrNot = true;
      }
      else if (this.route.url == "/Home" || this.route.url == "/myBookmarks" || this.route.url == "/crossreference" || this.route.url == "/myaccountdetails" ||
        this.route.url == "/MyHistory" || this.route.url == "/myAnnotations" || this.route.url == "/pendingcontentsystemagreement" || this.route.url == "/pendingcontentintegeration" || this.route.url == "/about-us" || this.route.url == "/copy-right"
        || this.route.url == "/terms-and-conditions" || this.route.url.includes("/help") || this.route.url.includes("/relatedproposedasus") || this.route.url.includes("/pcsfaq") || this.route.url.includes("/RedisCacheManagement") ||
        this.route.url == "/pendingcontentsystem" || this.route.url == "/supersededstandards" || this.route.url == "/aicpa" || this.route.url == "/conceptsstatements" || this.route.url == "/search" || this.route.url == "/taxonomyelementsreferencefile") {
        this.displayOption = false;
      }
      else if (this.route.url == "/MasterGlossary") {
        this.displayOption = true
        this.DisplayValue[0].DisplayOrNot = false;
        this.DisplayValue[1].DisplayOrNot = true;
        this.DisplayValue[2].DisplayOrNot = false;
      }
    }
    else if (routerpart.length == 4) {
      if (this.route.url.includes("archiveContent")) {
        this.displayOption = true;
        this.DisplayValue[0].DisplayOrNot = false;
        this.DisplayValue[1].DisplayOrNot = true;
        this.DisplayValue[2].DisplayOrNot = false;
      }
      else if (this.navData.crumbData != null) {
        if (this.navData.crumbData[0] != "Other Sources" && (!this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements"))) {
          this.displayOption = true;
          this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
          this.DisplayValue[1].DisplayOrNot = true;
          this.DisplayValue[2].DisplayOrNot = true;
        }
        else if (this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements")) {
          this.displayOption = true;
          this.DisplayValue[0].DisplayOrNot = false;
          this.DisplayValue[1].DisplayOrNot = false;
          this.DisplayValue[2].DisplayOrNot = true;
        }
        else {
          this.displayOption = false;
        }
      }
      else {
        let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (leftNavigation == undefined) {
          this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
            this.navData = JSON.parse(JSON.stringify(data));
          });
        }
        else {
          this.getBreadcrumb(this.route.url);
        }
        if (this.navData.crumbData != null) {
          if (this.navData.crumbData[0] != "Other Sources" && (!this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements"))) {
            this.displayOption = true;
            this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
            this.DisplayValue[1].DisplayOrNot = true;
            this.DisplayValue[2].DisplayOrNot = true;
          }
          else if (this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements")) {
            this.displayOption = true;
            this.DisplayValue[0].DisplayOrNot = false;
            this.DisplayValue[1].DisplayOrNot = false;
            this.DisplayValue[2].DisplayOrNot = true;
          }
          else {
            this.displayOption = false;
          }
        }
        else {
          this.displayOption = false;
        }
      }
    }
    else if (routerpart.length == 3 && !this.route.url.includes("tableOfContent")) {
      if (this.navData.crumbData != null) {
        if (this.navData.crumbData[0] != "Other Sources" && (!this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements"))) {
          this.displayOption = true;
          this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
          this.DisplayValue[1].DisplayOrNot = true;
          this.DisplayValue[2].DisplayOrNot = true;
        }
        else if (this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements")) {
          this.displayOption = true;
          this.DisplayValue[0].DisplayOrNot = false;
          this.DisplayValue[1].DisplayOrNot = false;
          this.DisplayValue[2].DisplayOrNot = true;
        }
        else {
          this.displayOption = true;
          this.DisplayValue[2].DisplayOrNot = true;
          this.DisplayValue[1].DisplayOrNot = false;
          this.DisplayValue[0].DisplayOrNot = false;
        }
      }
      else {
        let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (leftNavigation == undefined) {
          this.graphQlService.GetBreadcrumbSession(this.route.url).subscribe(data => {
            this.navData = JSON.parse(JSON.stringify(data));
          });
        }
        else {
          this.getBreadcrumb(this.route.url);
        }
        if (this.navData.crumbData != null) {
          if (this.navData.crumbData[0] != "Other Sources" && (!this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements"))) {
            this.displayOption = true;
            this.DisplayValue[0].DisplayOrNot = (this.userSessionRole != "Academic" && this.userSessionRole != "Basic") ? true : false;
            this.DisplayValue[1].DisplayOrNot = true;
            this.DisplayValue[2].DisplayOrNot = true;
          }
          else if (this.navData.crumbData[this.navData.crumbData.length - 1].toLowerCase().includes("75 gaap taxonomy elements")) {
            this.displayOption = true;
            this.DisplayValue[0].DisplayOrNot = false;
            this.DisplayValue[1].DisplayOrNot = false;
            this.DisplayValue[2].DisplayOrNot = true;
          }
          else {
            this.displayOption = true;
            this.DisplayValue[2].DisplayOrNot = true;
            this.DisplayValue[1].DisplayOrNot = false;
            this.DisplayValue[0].DisplayOrNot = false;
          }
        }
        else {
          this.displayOption = true;
          this.DisplayValue[2].DisplayOrNot = true;
          this.DisplayValue[1].DisplayOrNot = false;
          this.DisplayValue[0].DisplayOrNot = false;
        }
      }
    }
    else if (routerpart.length == 3 && this.route.url.includes("tableOfContent")) {
      this.displayOption = true;
      this.DisplayValue[2].DisplayOrNot = true;
      this.DisplayValue[1].DisplayOrNot = false;
      this.DisplayValue[0].DisplayOrNot = false;
    }
  }

  printPreviewOverlay() {

    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("print preview");
    this.commonDataService.closeModalOption.next(false);
  }

  globalPrint() {
    this.commonDataService.printpreviewFileName.next("");
    this.printPreviewOverlay();
    let str = `<div class="printBox">`;
    var hide = document.getElementsByClassName("print-content-hide")
    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "none";
    });
    var contents = document.getElementsByClassName("print-all-content");

    if (contents.length == 0 && this.route.url == "/crossreference") {
      this.hideGenerateReportPrintPreview();
    }
    Array.prototype.forEach.call(contents, function (element) {
      str += `<div> ${element.innerHTML} </div>`;
    });
    str += '</div>'

    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "block";
    });

    setTimeout(() => {
      document.getElementById("printPreviewArticle").innerHTML = "";
      document.getElementById("printPreviewArticle").innerHTML += str;
      const pageHeading = document.getElementById("pageHeading");
      if (pageHeading?.innerHTML) {
        document.getElementById("pageHeadingprint").innerHTML = pageHeading.innerHTML;
      //} else {
      //  document.getElementById("pageHeaderLine").style.display = "none";
      }
    }, 1000)
  }

  //PrintWithSource() {
  //  this.commonDataService.showLoader.next(true);
  //  this.commonDataService.printpreviewFileName.next("PP_withallsources");
  //  this.printPreviewOverlay();
  //  let str = `<div class="printBox">`;
  //  var hide = document.getElementsByClassName("print-content-hide")
  //  //Array.prototype.forEach.call(hide, function (obj) {
  //  //  obj.style.display = "none";
  //  //});

  //  for (let i = 0; i < hide.length; i++) {
  //    (hide[i] as HTMLElement).style.display = "none";
  //  }

  //  var contents = document.getElementsByClassName("print-all-content");
  //  if (contents.length == 0 && this.route.url == "/crossreference") {
  //    this.hideGenerateReportPrintPreview();
  //  }
  //  let index = 0;
  //  const batchSize = 10;
  //  const processBatch = () => {
  //    const endIndex = Math.min(index + batchSize, contents.length);
  //    for (let i = index; i < endIndex; i++) {
  //      str += '<div>' + contents[i].innerHTML + '</div>';
  //    }
  //    index = endIndex;

  //    if (index < contents.length) {
  //      setTimeout(processBatch, 0);
  //    } else {
  //      str += '</div>';

  //      for (let i = 0; i < hide.length; i++) {
  //        (hide[i] as HTMLElement).style.display = "block";
  //      }

  //      finalizePrint(str);

  //    }
  //  };

  //  const finalizePrint = (str) => {
  //    setTimeout(() => {
  //      document.getElementById("printPreviewArticle").innerHTML = "";
  //      document.getElementById("printPreviewArticle").innerHTML += str;
  //      const pageHeading = document.getElementById("pageHeading");
  //      if (pageHeading?.innerHTML) {
  //        document.getElementById("pageHeadingprint").innerHTML = pageHeading.innerHTML;
  //      }
  //      //else {
  //      //  document.getElementById("pageHeaderLine").style.display = "none";
  //      //}
  //      let sourcesObj = {
  //        paragraphId: 'all paragraphs',
  //        toggleValue: 'true'
  //      };
  //      this.commonDataService.displayAllSourcesForPrint.next(sourcesObj);
  //      if (this.route.url == "/MasterGlossary" && (sessionStorage.getItem("asc_displayAllSources") || this.commonDataService.printpreviewFileName.getValue() == "PP_withallsources")) {
  //        this.commonDataService.glossaryShowSource.next(true);
  //      }
  //      this.commonDataService.showLoader.next(false);
  //    }, 1000);
  //  }
  //  processBatch();
  //}
  // angular based declarations

  PrintWithSource(): void {
   this.commonDataService.showLoader.next(true);
   this.commonDataService.printpreviewFileName.next("PP_withallsources");
   this.printPreviewOverlay();
    
   var hide = document.getElementsByClassName("print-content-hide")

   for (let i = 0; i < hide.length; i++) {
     (hide[i] as HTMLElement).style.display = "none";
   }

    const elements = Array.from(document.getElementsByClassName('print-all-content'));
    const contents = elements.map(el => this.sanitizer.bypassSecurityTrustHtml(el.outerHTML));

    const pageHeading = document.getElementById("pageHeading")
   if (contents.length == 0 && this.route.url == "/crossreference") {
     this.hideGenerateReportPrintPreview();
   }
   
   for (let i = 0; i < hide.length; i++) {
     (hide[i] as HTMLElement).style.display = "block";
   }

   let sourcesObj = {
     paragraphId: 'all paragraphs',
     toggleValue: 'true'
   };
   this.commonDataService.displayAllSourcesForPrint.next(sourcesObj);
   if (this.route.url == "/MasterGlossary" && (sessionStorage.getItem("asc_displayAllSources") || this.commonDataService.printpreviewFileName.getValue() == "PP_withallsources")) {
     this.commonDataService.glossaryShowSource.next(true);
    }
    this.callROC.emit({ "contents": contents, "pageHeading": pageHeading?.innerHTML });
    setTimeout(() => {
     this.applySourceTransformation();
      this.commonDataService.showLoader.next(false);
    }, 500);
  

  }

  applySourceTransformation() {
    const modelElement = document.getElementById('print-preview-content-main');
    
    const span = modelElement.querySelectorAll('.sfragment');
    span.forEach((sp: HTMLElement) => {
      sp.classList.add('show-sources-sfragment');
      sp.style.display = 'inline';
    });
    const spans = modelElement.querySelectorAll('.hide-content.sfragment-data');
    spans.forEach((span: HTMLElement) => {
      const sname = span.querySelector('.sfragment-standard-name')?.textContent?.trim() ?? '';
      const snum = span.querySelector('.sfragment-standard-number')?.textContent?.trim() ?? '';
      const pnum = span.querySelector('.sfragment-para-number')?.textContent?.trim() ?? '';
        span.classList.add('show-sources-sfragment-data');
        span.style.display = 'inline';
      
    });
    modelElement.querySelectorAll('.print-all-content').forEach((el) => {
      (el as HTMLElement).classList.remove('ml-3', 'ml-invert-1', 'mb-2','flex-display');
    });
    
  }
  hideGenerateReportPrintPreview() {
    this.commonDataService.CrossRefReportNotGenerated.next(false);
    this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.GenerateReportPrintMessage
    });
  }

  SortObjectByProperty(property) {
    return function (a, b) {
      let A;
      let B;
      let result;
      let filtered_a = a[property]?.replace(/-/g, '');
      let filtered_b = b[property]?.replace(/-/g, '');

      let alphanumericCompare = filtered_a.length - filtered_b.length || filtered_a.localeCompare(filtered_b);

      if (/\d/.test(a[property]) && /\d/.test(b[property])) {
        A = parseInt(a[property]?.match(/\d/g)?.join(''));
        B = parseInt(b[property]?.match(/\d/g)?.join(''));
        result = A < B ? -1 : (A > B ? 1 : (alphanumericCompare));
      }
      else {
        result = alphanumericCompare;
      }
      return result;
    }
  }

  sortObject() {
    return function (a, b) {
        let subTopicSort = Number(a["subtopicNumber"]) - Number(b["subtopicNumber"]);
      if (subTopicSort == 0) {
        if (a["sectionNumber"].includes("S") && (!b["sectionNumber"].includes("S"))) {
            return 1;
          }
        else if ((!a["sectionNumber"].includes("S")) && b["sectionNumber"].includes("S")) {
            return -1;
          }
        else {
            let sectionSort = Number(a["sectionNumber"].replace("S", "")) - Number(b["sectionNumber"].replace("S", ""));
          if (sectionSort == 0) {
            let filtered_a = a["id"]?.replace(/-/g, '');
            let filtered_b = b["id"]?.replace(/-/g, '');

            let alphanumericCompare = filtered_a.length - filtered_b.length || filtered_a.localeCompare(filtered_b);
            if (/\d/.test(a["id"]) && /\d/.test(b["id"])) {
              let aId = parseInt(a["id"]?.match(/\d/g)?.join(''));
              let bId = parseInt(b["id"]?.match(/\d/g)?.join(''));
              return aId < bId ? -1 : (aId > bId ? 1 : (alphanumericCompare));
            }
            else {
              return alphanumericCompare;
            }
          }
          else {
            return sectionSort;
          }
          }
        }
      else {
          return subTopicSort;
        }
      }
  }

  groupBy = key => (result, current) => {
    const item = Object.assign({}, current);
    if (typeof result[current[key]] == 'undefined') {
      result[current[key]] = [item];
    } else {
      result[current[key]].push(item);
    }
    return result;
  };

  getUnique(array) {
    var uniqueArray = [];
    // Loop through array values
    for (let i = 0; i < array.length; i++) {
      if (uniqueArray.indexOf(array[i]) === -1) {
        uniqueArray.push(array[i]);
      }
    }
    return uniqueArray;
  }

  printpreview(printobj) {
    this.commonDataService.printTrigger.next(true);
    this.addPendingContent();
    this.commonDataService.currentParagraph.next("");
    if (printobj != null && printobj.labels[0] === this.printselected[0]) {
      if (this.printQueueCount > 0) {
        this.printPreviewOverlay();
      }
      this.commonDataService.printpreviewFileName.next("");
      //let str = `<div class="printBox mt-1rem">`;
      let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
      if (printQueueData != null) {

        if (printQueueData.ParagraphIdsList != null) {
          let str = `<div class="printBox mt-1rem">`;

          let allQueueData = [];
          for (var i = 0; i < printQueueData.ParagraphIdsList.length; i++) {
            allQueueData.push({ id: printQueueData.ParagraphIdsList[i].id, guid: printQueueData.printQueueAddedList[i].guid, isSec: printQueueData.ParagraphIdsList[i].isSecParagraph, isGlossary: printQueueData.ParagraphIdsList[i].isGlossaryParagraph, topicNumber: printQueueData.printQueueAddedList[i].topicNumber, subtopicNumber: printQueueData.printQueueAddedList[i].subTopicNumber, sectionNumber: printQueueData.printQueueAddedList[i].sectionNumber });
          }

          //separate array based on => section => sec => then sort by id => combine
          //let allData = [];
          //let secQueue = [];
          //let nonSecQueue = [];

          //const sectionArrs: Object = allQueueData.reduce(this.groupBy('sectionNumber'), {});
          //console.log(sectionArrs);
          //let SectionKeys = Object.keys(sectionArrs).sort((a, b) => a.localeCompare(b));
          //console.log(SectionKeys);

          //for (let i = 0; i < SectionKeys.length; i++) {
          //  secQueue = sectionArrs[SectionKeys[i]]?.filter(a => a?.isSec?.toString()?.toLowerCase() === "true");
          //  nonSecQueue = sectionArrs[SectionKeys[i]]?.filter(a => a?.isSec?.toString()?.toLowerCase() !== "true");

          //  secQueue.sort(this.SortObjectByProperty('id'));
          //  nonSecQueue.sort(this.SortObjectByProperty('id'));

          //  allData = allData.concat(nonSecQueue.concat(secQueue));
          //}


          allQueueData.sort(this.sortObject());

          allQueueData.forEach(function (result, j) {
            let contentValue = document.getElementById(result.guid)?.outerHTML;
            if (contentValue) {
              let paraNum = "";
              if (allQueueData != null) {
                paraNum = allQueueData[j].id;
              }
              var content = contentValue;
              if (result.isGlossary) {
                str += `<div>
                        <div class="width-91">
                        <div class="mb-1">
                        <h4 class="right-overlay-heading">
                        <div class="singleLine highlight-blue border-bottom-help">${paraNum}</div>
                        </h4>
                        </div>
                        </div>

                        <div class="flex-display width-91"><div class="flex-display width-100">
                        <div class="paragraphId width-2">
                        </div>
                        <div role="region" class="print-content width-90">
                        <article>${content}</article><br/></div></div></div></div>`;
              }
              else {
                str += `
                        <div class="printShow">
                          <div class="containerP">
                            <div class="pn pnId col-2 singleLine" style="float: left; width: 15%;">${paraNum}</div>
                            <div></div>
                            <div role="region" class="col-10" style="float: right; width:85% !important;">
                              <article>${content}</article>
                            </div>
                          </div>
                        </div>
                        <br/>`;
              }
            }
          });
          str += '</div>'
          setTimeout(() => {
            document.getElementById("printPreviewArticle").innerHTML = "";
            document.getElementById("printPreviewArticle").innerHTML += str;
            const pageHeading = document.getElementById("pageHeading");
            if (pageHeading?.innerHTML) {
              document.getElementById("pageHeadingprint").innerHTML = pageHeading.innerHTML;
            }
            let headers = document.getElementById("printPreviewArticle").getElementsByClassName('componentHeader') as HTMLCollectionOf<HTMLElement>;
            if (headers) {
              Array.prototype.forEach.call(headers, (header: HTMLElement) => {
                header.style.marginLeft = '-1rem';
              });
            }
          }, 1000)
        }
      }
    }
    if (printobj != null && printobj.labels[0] === this.globalprint[0]) {
      this.globalPrint();
    }
    if (printobj != null && printobj.labels[0] === this.printannotations[0]) {
      // if (this.DisplayValue[0].labels[0] == this.displayAllAnnotations[0]) {
      this.commonDataService.displayallannotation.next("displayallannotationswithprint");
      this.commonDataService.printpreviewFileName.next("PP_withallannotations");
      this.printPreviewOverlay();
      //}
      //else {
      //  this.globalPrint();
      //}
    }
    if (printobj != null && printobj.labels[0] === this.printSources[0]) {
      this.PrintWithSource();
    }
  }

  displayAll(obj: any) {
    this.commonDataService.printwithannotations.next("");
    if (obj.labels == this.displayAllAnnotations) {
      this.commonDataService.displayallannotation.next("displayallannotations");
      this.DisplayValue.filter(x => x.labels == this.displayAllAnnotations)[0].labels = this.HideAllAnnotations
    }
    else if (obj.id == 'displayAllSources') {

      obj = this.DisplayValue.filter(a => a.id == 'displayAllSources')[0];
      let index = this.DisplayValue.indexOf(obj);

      let toggleSourcesValue: string;

      if (obj.labels[0].toLowerCase() == "Display all sources".toLowerCase()) {
        obj.labels = ["Hide all sources"];
        toggleSourcesValue = 'true';
        sessionStorage.setItem("asc_displayAllSources", "true");
        this.commonDataService.glossaryShowSource.next(true);
      }
      else {
        obj.labels = ["Display all sources"];
        toggleSourcesValue = 'false';
        sessionStorage.setItem("asc_displayAllSources", "false");
        this.commonDataService.glossaryShowSource.next(false);
      }

      if (index != -1) {
        this.DisplayValue[index] = obj;
      }

      let sourcesObj = {
        paragraphId: 'all paragraphs',
        toggleValue: toggleSourcesValue
      }
      this.commonDataService.displayAllSources.next(sourcesObj);
    }
    else if (obj.labels == this.HideAllAnnotations) {
      this.commonDataService.displayallannotation.next("hideallannotations");
      this.DisplayValue.filter(x => x.labels == this.HideAllAnnotations)[0].labels = this.displayAllAnnotations
      this.commonDataService.showLoader.next(false);
    }
    else if (obj.labels == this.hideSecContent) {
      localStorage.setItem("DefaultSecView", "false")
      this.commonDataService.showSecContent.next(false);
      this.DisplayValue.splice(-1);
      this.DisplayValue.push({
        'labels': this.displaySecContent, 'imgPath': '../../../assets/icons/layout-list-thumb.svg',
        'id': 'displaySecContent', 'alt': 'Sec Content', 'DisplayOrNot': true
      });
      this.GetDisplayLables();
      if (this.navData.crumbData?.length != 0 && this.navData.menuData?.length != 0) {
        this.navData.menuData = this.navData.menuData?.filter(x => !x.menuItem.startsWith("S"));
        this.breadCrumbMenuData = this.navData.menuData;
      }
      this.hiddenContentSECFlag = true;
    }
    else if (obj.labels == this.displaySecContent) {
      localStorage.setItem("DefaultSecView", "true")
      this.commonDataService.showSecContent.next(true);
      this.DisplayValue.splice(-1);
      this.DisplayValue.push({
        'labels': this.hideSecContent, 'imgPath': '../../../assets/icons/layout-list-thumb.svg',
        'id': 'hideSecContent', 'alt': 'Sec Content', 'DisplayOrNot': true
      });
      this.GetDisplayLables();
      if (this.route.url.split("/").pop().includes("showallinonepage") || this.route.url.split("/").pop().includes("showallinonepageplus")) {
        this.getLeftNavData();
      }
      if (this.navData.crumbData?.length != 0 && this.navData.menuData?.length != 0) {
        this.navData.menuData = this.clonedNavData.menuData;
        this.breadCrumbMenuData = this.navData.menuData;
      }
      this.hiddenContentSECFlag = false;
    }
  }
  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any }[] = [];
  pagepubllist: { sectionarray: object[], sectionname: string, mainsectionname: string }[] = [];
  getLeftNavData() {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    let breadcrumbData = JSON.parse(localStorage.getItem("footerBreadCrumb"));

    this.graphQlService.getLeftNavigation().subscribe(leftNavData => {
      if (leftNavData) {
        let url = this.route.url.split("/");
        let obj;
        if (url[1] == url[2]) {
          if (breadcrumbData.crumbData.find(x => x.split(" ")[0].includes("X")) == undefined) {
            obj = leftNavData.filter(x => x.item == breadcrumbData.crumbData[0])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[1])[0];
          }
          else {
            obj = leftNavData.filter(x => x.item == breadcrumbData.crumbData[0])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[1])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[2])[0];
          }
        }
        else {
          if (breadcrumbData.crumbData.find(x => x.split(" ")[0].includes("X")) == undefined) {
            obj = leftNavData.filter(x => x.item == breadcrumbData.crumbData[0])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[1])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[2])[0];
          }
          else {
            obj = leftNavData.filter(x => x.item == breadcrumbData.crumbData[0])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[1])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[2])[0].itemData.filter(x => x.item == breadcrumbData.crumbData[3])[0];
          }
        }
        this.getPubpageId(obj);
        localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
      }
    })
  }
  getPubpageId(obj) {
    let CurrentPubPageId = JSON.parse(localStorage.getItem("publpageId"));
    if (obj.itemData != null) {
      for (let items of obj.itemData) {
        this.getPubpageId(items);
        if (items.afterShowAllInOnePageRequired) {
          break;
        }
      }
    }
    if (obj.itemLink != null) {
      if (obj.itemLink.length > 0) {
        let PublpageId = obj.itemLink.split('/').map(d => d);
        this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: PublpageId[2], pageurl: obj.itemLink });
      }
    }
    else {
      if (this.pagepublicationId.length > 0) {

        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: CurrentPubPageId[0].mainsectionname });
        this.pagepublicationId = [];
      }
    }
  }

  deletePrintQueueForNewPage() {
    localStorage.removeItem("SetPrintQueueSession");
    localStorage.removeItem("printQueueCount");
    this.printQueueCount = 0;
    var hide = document.getElementsByClassName("Print-Queue-icon")
    Array.prototype.forEach.call(hide, function (obj) {
      obj.style.display = "none"
    });
    this.commonDataService.printCount.next("toggleOff");
    this.commonDataService.printToggleOff.next("printToggleOff");
  }

  deletePrintQueue(printobj) {
    if (printobj.deletedIcon && this.printQueueCount > 0) {
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.deleteAllPrintQueue
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.commonDataService.isConfirmationPopUpOpen.next(false);
          this.commonDataService.showLoader.next(true);

          localStorage.removeItem("SetPrintQueueSession");
          localStorage.removeItem("printQueueCount");
          this.printQueueCount = 0;
          var hide = document.getElementsByClassName("Print-Queue-icon")
          Array.prototype.forEach.call(hide, function (obj) {
            obj.style.display = "none"
          });
          this.commonDataService.showLoader.next(false);
          this.commonDataService.printCount.next("toggleOff");
          this.commonDataService.printToggleOff.next("printToggleOff");
        }
      });
    }
  }

  navigateToTOC(crumbObj) {
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    let paranum: string = "";
    for (let i = 1; i < this.navData.crumbData.length; i++) {
      if (!this.navData.crumbData[i].split(" ")[0].includes("X")) {
        if (this.navData.crumbData[i] == crumbObj) {
          paranum += crumbObj.split(" ")[0];
          //this.route.navigateByUrl("/" + paranum + "/tableOfContent");
          this.popupRedirect("/" + paranum + "/tableOfContent");
          break;
        }
        else {
          paranum += this.navData.crumbData[i].split(" ")[0] + "-";
        }
      }
    }
  }
  onRightClick(event, obj?: any) {
    if (obj.displayText != "Contact Us") {
      if (obj.displayText == "Terms and Conditions") {
        this.commonDataService.tcsource.next("");
      }
      event.target.href = obj.link;
    }

  }
  menuData;
  crumbData;
  secUrlBreadcrumb;
  getBreadcrumb(breadcerumbUrl) {
    if (breadcerumbUrl.startsWith("help") || breadcerumbUrl.startsWith("relatedproposedasus") || breadcerumbUrl.startsWith("pcsfaq")) { breadcerumbUrl = "help"; }
    else if (breadcerumbUrl == "pendingcontentsystem" || breadcerumbUrl == "pendingcontentintegeration") { breadcerumbUrl = "pendingcontentsystemagreement"; }
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = leftNavigation.length - 1; i >= 0; i--) {
      this.crumbData = [];
      this.menuData = [];
      this.secUrlBreadcrumb = "";
      if (leftNavigation[i].itemData != null && leftNavigation[i].itemData.length > 0) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {

          if (leftNavigation[i].itemData[j].itemLink != null && leftNavigation[i].itemData[j].itemLink != "") {
            if (leftNavigation[i].itemData[j].itemLink.includes(breadcerumbUrl)) {
              this.crumbData.push(leftNavigation[i].item);
              this.crumbData.push(leftNavigation[i].itemData[j].item);
              this.getMenuData(leftNavigation[i].itemData);
              this.navData.crumbData = this.crumbData;
              this.navData.menuData = this.menuData;
              return;
            }
          } else {
            if (leftNavigation[i].itemData[j].itemData != null) {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemLink != "") {
                  if (leftNavigation[i].itemData[j].itemData[k].itemLink == breadcerumbUrl) {
                    this.crumbData.push(leftNavigation[i].item);
                    this.crumbData.push(leftNavigation[i].itemData[j].item);
                    this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                    this.getMenuData(leftNavigation[i].itemData[j].itemData);
                    this.navData.crumbData = this.crumbData;
                    this.navData.menuData = this.menuData;
                    return;
                  }
                } else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != "") {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink == breadcerumbUrl) {
                          this.crumbData.push(leftNavigation[i].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                          this.getMenuData(leftNavigation[i].itemData[j].itemData[k].itemData);
                          this.navData.crumbData = this.crumbData;
                          this.navData.menuData = this.menuData;
                          return;
                        }
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink == breadcerumbUrl) {
                              this.crumbData.push(leftNavigation[i].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                              this.getMenuData(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData);
                              this.navData.crumbData = this.crumbData;
                              this.navData.menuData = this.menuData;

                              return;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.navData.crumbData = null;
    this.navData.menuData = null;
    return
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    breadcerumbUrl = breadcerumbUrl.replace("-navPath", "");
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = leftNavigation.length - 1; i >= 0; i--) {
      this.crumbData = [];
      this.menuData = null;
      this.navData.menuData = this.menuData;
      this.secUrlBreadcrumb = "";
      if (leftNavigation[i].itemData != null && leftNavigation[i].itemData.length > 0) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            this.crumbData.push(leftNavigation[i].item);
            this.crumbData.push(leftNavigation[i].itemData[j].item);
            this.navData.crumbData = this.crumbData;
            if (!this.route.url.includes("tableOfContent") && !this.route.url.includes("showallinonepage") && !this.route.url.includes("showallinonepageplus")) {
              this.getMenuData(leftNavigation[i].itemData);
              this.navData.menuData = this.menuData;
            }
            return;
          } else {
            if (leftNavigation[i].itemData[j].itemData != null) {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  this.crumbData.push(leftNavigation[i].item);
                  this.crumbData.push(leftNavigation[i].itemData[j].item);
                  this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                  this.navData.crumbData = this.crumbData;
                  if (!this.route.url.includes("tableOfContent") && !this.route.url.includes("showallinonepage") && !this.route.url.includes("showallinonepageplus")) {
                    this.getMenuData(leftNavigation[i].itemData[j].itemData);
                    this.navData.menuData = this.menuData;
                  }
                  return;
                } else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        this.crumbData.push(leftNavigation[i].item);
                        this.crumbData.push(leftNavigation[i].itemData[j].item);
                        this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                        this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                        this.navData.crumbData = this.crumbData;
                        if (!this.route.url.includes("tableOfContent") && !this.route.url.includes("showallinonepage") && !this.route.url.includes("showallinonepageplus")) {
                          this.getMenuData(leftNavigation[i].itemData[j].itemData[k].itemData);
                          this.navData.menuData = this.menuData;
                        }
                        return;
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              this.crumbData.push(leftNavigation[i].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                              this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                              this.navData.crumbData = this.crumbData;
                              if (!this.route.url.includes("tableOfContent") && !this.route.url.includes("showallinonepage") && !this.route.url.includes("showallinonepageplus")) {
                                this.getMenuData(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData);
                                this.navData.menuData = this.menuData;
                              }
                              return;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.navData.crumbData = null;
    this.navData.menuData = null;
    return
  }

  getMenuData(leftnav) {
    this.menuData = [];
    for (let i = 0; i < leftnav.length; i++) {
      this.menuData.push({ menuItem: leftnav[i].item, menuUrl: leftnav[i].itemLink, isSecContent: leftnav[i].item.startsWith('S') ? true : false });
    }
  }

  toggleAnnotationFooterLabel() {
    if (this.yourAnnotationCount?.length > 0) {
      let obj = this.DisplayValue.filter(a => a.id == "displayAllAnnotations")[0];
      let index = this.DisplayValue.indexOf(obj);
      obj.labels = this.HideAllAnnotations;
      if (index != -1) {
        this.DisplayValue[index] = obj;
      }
    }
    else {
      let displayAllAnnotations = this.DisplayValue.filter(a => a.id == "displayAllAnnotations")[0];
      if (displayAllAnnotations) {
        let obj = displayAllAnnotations;
        let index = this.DisplayValue.indexOf(obj);
        obj.labels = this.displayAllAnnotations;
        if (index != -1) {
          this.DisplayValue[index] = obj;
        }
      }
    }
  }

  addPendingContent() {
    let ImageDivs = document.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
    
    if (ImageDivs.length > 0) {
      for (let i = 0; i < ImageDivs.length; i++) {
        if (!ImageDivs[i].className.includes("formatted")) {
          let normText = ImageDivs[i].getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;
          if (i == 0 && normText.length == 0) {
            ImageDivs[i].className += " mt-0";
          }
          ImageDivs[i].className += " formatted"
          let divBlock = document.createElement("div");
          let img = document.createElement("img");
          img.src = "../../../../assets/icons/clock-black.svg";
          img.alt = "Clock Image";
          img.className = "pending-clock-icon"
          let imgQuestion = document.createElement("img");
          imgQuestion.src = "../../../../assets/icons/Help.svg";
          imgQuestion.alt = "Question Image";
          imgQuestion.className = "pending-question-icon cursor-pointer";
          imgQuestion.id = "/helppendingcontent";
          let textBlock = document.createElement("span");
          textBlock.innerText = "PENDING CONTENT";
          textBlock.className = "mat-Info";
          divBlock.appendChild(img);
          divBlock.appendChild(textBlock);
          divBlock.appendChild(imgQuestion);
          divBlock.className = "bottomMargin";
          ImageDivs[i].insertBefore(divBlock, ImageDivs[i].firstChild);
          let dateSection = ImageDivs[i].getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

          if (dateSection.length > 0) {
            for (let j = 0; j < dateSection.length; j++) {
              let divBlock1 = document.createElement("div");
              divBlock1.className = "mt-1rem";
              dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
              dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
              dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

              let guidanceLink = dateSection[j].nextElementSibling;
              if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
                guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
              }
            }
          }
        }
      }
    }
  }
  
}

